/* Scoped purchase-choice bridge for the unpublished Puhasta theme. */
(() => {
  const init = async root => {
    await Promise.all([customElements.whenDefined('shrine-subscription-widget'), customElements.whenDefined('quantity-breaks')]);
    const id = root.dataset.section;
    const widget = document.getElementById('SubscriptionWidget-' + id);
    const packs = document.getElementById('quantity-breaks-' + id);
    const form = document.getElementById('product-form-' + id);
    if (!widget || !packs || !form || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const box = widget.querySelector('[data-type="subscription"]');
    const variantInput = form.querySelector('[name="id"]');
    if (!box || !variantInput) return;
    widget.classList.add('puhasta-choice-widget');
    const scope = form.closest('section') || document;
    const buttons = [...scope.querySelectorAll('[id^="ProductSubmitButton-"], [id^="SectionAtcBtn-"]')];
    const initialDisabled = buttons.map(b => b.disabled);
    const status = root.querySelector('[data-choice-status]');
    const totals = root.dataset.oneTimeTotals.split(',').map(Number);
    const subscriptionVariant = root.dataset.subscriptionVariant;
    const oneTimeVariant = root.dataset.oneTimeVariant;
    const oneTimeAvailable = Boolean(oneTimeVariant) && root.dataset.oneTimeAvailable === 'true';
    box.setAttribute('role', 'checkbox'); box.setAttribute('tabindex', '0');
    box.setAttribute('aria-label', 'Vali püsitellimus ja säästa');
    box.addEventListener('keydown', e => { if(e.key === ' ' || e.key === 'Enter') { e.preventDefault(); box.click(); } });
    const money = cents => new Intl.NumberFormat('et-EE', {style:'currency',currency:'EUR'}).format(cents / 100);
    const setText = (el, html) => { if (el.innerHTML !== html) el.innerHTML = html; };
    const update = () => {
      const checked = box.classList.contains('subscription__box--selected');
      box.setAttribute('aria-checked', String(checked));
      const selectedVariant = checked ? subscriptionVariant : oneTimeVariant;
      variantInput.value = selectedVariant || subscriptionVariant;
      if (Array.isArray(packs.formVariants) && packs.formVariants.length) {
        packs.formVariants = packs.formVariants.map(v => String(v) === subscriptionVariant || String(v) === oneTimeVariant ? selectedVariant : v);
      }
      form.querySelectorAll('[name="selling_plan"]').forEach(input => {
        input.value = checked ? widget.selectedPlanId || widget.dataset.firstSellingPlanId : '';
        input.disabled = !checked;
      });
      buttons.forEach((b,i) => {
        const unavailable = checked ? initialDisabled[i] : !oneTimeAvailable;
        if (!b.classList.contains('loading') && b.getAttribute('aria-disabled') !== 'true') b.disabled = unavailable;
        b.setAttribute('aria-describedby', root.id);
      });
      setText(status, checked ? 'Püsitellimus · Tasuta tarne' : oneTimeAvailable ? 'Üksikost · Tarne 2,49 € · Püsitellimust ei lisandu' : 'Üksikost ei ole praegu saadaval.');
      let selectedPrice, selectedCompare;
      const selectedQuantity = Number(packs.querySelector('input:checked')?.value || packs.selectedQuantity);
      packs.querySelectorAll('.quantity-break[data-quantity]').forEach(label => {
        const qty = Number(label.dataset.quantity);
        const subscription = Math.round(Number(packs.dataset.basePrice) * qty * Number(label.dataset.percentageLeft) - Number(label.dataset.fixedDiscount));
        const price = checked ? subscription : totals[qty-1];
        const compare = Number(label.dataset.baseComparePrice) * qty;
        if(!Number.isFinite(price)) return;
        const values = {price:money(price),compare_price:money(compare),amount_saved:money(compare-price),amount_saved_rounded:money(Math.round((compare-price)/100)*100),percentage_saved:Math.round((compare-price)/compare*100)+'%',quantity:String(qty),price_each:money(Math.round(price/qty)),compare_price_each:money(Math.round(compare/qty))};
        label.querySelectorAll('.variant-price-update[data-text]').forEach(el => setText(el,el.dataset.text.replace(/\[([a-z_]+)\]/g,(match,key) => values[key] ?? match)));
        if(selectedQuantity === qty) { selectedPrice=price; selectedCompare=compare; }
      });
      if(selectedPrice !== undefined) {
        scope.querySelectorAll('.main-atc-price, [id^="sticky-atc-separate-price-"] .price-item--sale, [id^="sticky-atc-separate-price-"] .price__regular .price-item').forEach(el => setText(el,money(selectedPrice)));
        scope.querySelectorAll('[id^="sticky-atc-separate-price-"] .price__compare-price .price-item').forEach(el => setText(el,money(selectedCompare)));
        scope.querySelectorAll('[id^="sticky-atc-separate-price-"] .badge__percentage-saved').forEach(el => setText(el,String(Math.round((selectedCompare-selectedPrice)/selectedCompare*100))));
      }
    };
    let scheduled = false;
    const queue = () => { if(!scheduled) { scheduled=true; requestAnimationFrame(() => {scheduled=false;update();}); } };
    box.addEventListener('click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const selected = !box.classList.contains('subscription__box--selected');
      box.classList.toggle('subscription__box--selected', selected);
      box.dataset.selected = String(selected);
      widget.isSubSelected = selected;
      update();
    }, true);
    packs.addEventListener('change', update);
    form.addEventListener('submit', e => {
      update();
      if (!box.classList.contains('subscription__box--selected') && !oneTimeAvailable) { e.preventDefault(); e.stopImmediatePropagation(); }
    },true);
    buttons.forEach(b => b.addEventListener('click',e => {
      update();
      if(b.id.startsWith('SectionAtcBtn-')) {
        e.preventDefault(); e.stopImmediatePropagation();
        const mainButton = form.querySelector('[type="submit"]');
        if(!b.disabled && mainButton && mainButton.getAttribute('aria-disabled') !== 'true') form.requestSubmit(mainButton);
      }
    },true));
    new MutationObserver(queue).observe(packs,{childList:true,subtree:true});
    update();
  };
  const start = () => document.querySelectorAll('[data-puhasta-choice-preview]').forEach(init);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',start);
})();
